export default __webpack_public_path__ + "static/media/villanova-crowd.f8e0d16f.png";